
export enum ServiceTypeCd {
	GUARANTEED_BY_12_NOON = 'GuaranteedBy12Noon',
	NORMAL = 'Normal',
	RAPID_REMOTE_SERVICE = 'RapidRemoteService',
	XPO_DEFERRED_EXPRESS = 'XPODeferredExpress'}

